import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Environment} from '../../shared/environment/environment';
import {Observable} from 'rxjs/internal/Observable';

@Injectable()
export class ApiGatewayService {

  constructor(private httpClient: HttpClient) {
  }

  public retrieveJwtToken(cpeId): Observable<string> {
    return this.httpClient.get(this.getBaseUrl() + '/jwt-redirect/private/jwt-service', {
      responseType: 'text',
      params: {'cpeid': cpeId}
    });
  }

  private getBaseUrl(): string {
    return Environment.environmentConfig().baseApiUrl;
  }

}
